<template>
  <div>
    <div class="ui placeholder segment" style="margin-bottom: 50px" v-if="employee.user.payslips.length < 1">
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noPayslipsHaveBeenAddedYet') }}
      </div>
      <div class="ui primary button" style="background-color: #092442"
           @click="showModal()"
           v-if="!employee.deleted_at">
        {{ $t('addPayslip') }}
      </div>
    </div>

    <div v-else style="margin-bottom: 50px">
      <div class="ui three columns grid" style="padding-top: 10px">
        <div class="row">
          <div class="column"></div>
          <div class="column"></div>
          <div class="right aligned column">
            <div class="ui very compact icon blue button"
                 style="background-color: #092442"
                 v-if="employee.user.payslips.length && !employee.deleted_at"
                 @click="showModal()">
              <i class="plus icon"></i>
              {{ $t('addPayslip') }}
            </div>
          </div>
        </div>
      </div>

      <div class="ui divider"></div>

      <abstractTable :columns="payslipsColumns" :data="payslipsData"
                     :classes="'ui very compact center aligned celled very basic table'"
                     :dataPerPage="12" :paginationEnable="true"
                     :paginationNextButtonText="$t('next')"
                     :paginationPervButtonText="$t('previous')"
                     :paginationFirstPageButtonText="$t('first')"
                     :paginationLastPageButtonText="$t('last')"
                     :addtionalColumnsNumber="3">
        <template slot="table-column">
          <th> {{ $t('bonuses') }} </th>
          <th> {{ $t('deductions') }} </th>
          <th> {{ $t('totalSalaryAmount') }} </th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td>
            <div :class="'price-popup'"
                 :id="'salary-bonuses-' + props.row.id"
                 @click="toggleThePopup('bonuses-' + props.row.id)">
              £ {{ listSumation(props.row.bonuses) }}
            </div>
            <div class="ui flowing fluid popup top left transition hidden">
              <table class="ui center aligend very compact  small collapsing table"
                     v-if="amountRightToBeShown(props.row.bonuses[0].amount)">
                <thead>
                  <tr class="center aligned">
                    <th>{{ $t('bonusAmount') }}</th>
                    <th>{{ $t('description') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="center aligned"
                      v-for="bonuse in props.row.bonuses"
                      v-if="amountRightToBeShown(bonuse.amount)">
                    <td>{{ bonuse.amount }}</td>
                    <td>{{ bonuse.description }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-else class="ui placeholder segment">
                <div class="ui icon header" style="color: #092442">
                  <i class="dont icon"></i>
                  {{ $t('noDeductionsForThisPayslip') }}
                </div>
              </div>
            </div>
          </td>
          <td>
            <div :class="'price-popup'"
                 :id="'salary-deductions-' + props.row.id"
                 @click="toggleThePopup('deductions-' + props.row.id)">
              £ {{ listSumation(props.row.salary_deductions) }}
            </div>
            <div class="ui flowing fluid popup top left transition hidden">
              <table class="ui center aligend very compact  small collapsing table"
                     v-if="props.row.salary_deductions.length && amountRightToBeShown(props.row.salary_deductions[0].amount)">
                <thead>
                  <tr class="center aligned">
                    <th>{{ $t('deductionAmount') }}</th>
                    <th>{{ $t('description') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="center aligned"
                      v-for="salaryDeduction in props.row.salary_deductions"
                      v-if="amountRightToBeShown(salaryDeduction.amount)">
                    <td>{{ salaryDeduction.amount }}</td>
                    <td>{{ salaryDeduction.description }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-else class="ui placeholder segment">
                <div class="ui icon header" style="color: #092442">
                  <i class="dont icon"></i>
                  {{ $t('noDeductionsForThisPayslip') }}
                </div>
              </div>
            </div>
          </td>
          <td>{{ props.row.totalSalaryAmount }}</td>
        </template>
      </abstractTable>
    </div>

    <div class="ui large longer modal" id="employee-payslip" style="margin-top: 10% !important">
      <div class="header">{{ $t('addPayslip') }}</div>
      <div class="scrolling content">
        <h2 class="ui left aligned icon header">
          {{ $t('basicSalary') }}: {{ employee.salary_amount }}
        </h2>

        <br/>

        <div class="ui two columns grid">
          <div class="column">
            <h3 class="ui dividing header">
              {{ $t('bonuses') }}
            </h3>
            <moneyForm :objectArray="[{description: '', amount: ''}]"
                       :placeholders="placeholders.bonus"
                       :widths="['30%', '70%']"
                       :columns="bonusColumns"
                       :clearData="wantToClear"
                       @onChange="bonusesEventListenner">
            </moneyForm>
          </div>

          <div class="column">
            <h3 class="ui dividing header">
              {{ $t('deductions') }}
            </h3>
            <moneyForm :objectArray="[{description: '', amount: ''}]"
                       :placeholders="placeholders.deduction"
                       :widths="['30%', '70%']"
                       :columns="deductionColumns"
                       :clearData="wantToClear"
                       @onChange="deductionsEventListenner">
            </moneyForm>
          </div>
        </div>

        <br/>

        <div class="ui horizontal divider">{{ $t('totalSalaryAmount') }}</div>

        <h1 class="ui center aligned header">
          £ {{ employee.salary_amount }} + £ {{ bonusesSum }} - £ {{ salaryDeductionsSum }} = £ {{ computedSalary  }}
        </h1>

        <div class="ui divider"></div>
        <div class="ui primary right floated button"
             :class="{ disabled: !bonusFormValid || !deductionFormValid }"
             style="background-color: #092442"
             @click="savePayslip()">
          Save
        </div>

        <div class="ui right floated button"
             @click="discardChanges()">
          Discard
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    moneyForm: require('@/components/abstract_components/MoneyForm').default
  },
  props: {
    employee: { type: Object, required: true }
  },
  data () {
    return {
      bonuses: [],
      salaryDeductions: [],
      bonusesSum: 0,
      salaryDeductionsSum: 0,
      bonusFormValid: true,
      deductionFormValid: true,
      placeholders: {
        bonus: {
          description: this.$t('bonusDescription'),
          amount: this.$t('bonusAmount')
        },
        deduction: {
          description: this.$t('deductionDescription'),
          amount: this.$t('deductionAmount')
        }
      },
      wantToClear: false
    }
  },
  computed: {
    bonusColumns () {
      return [
        {name: this.$t('bonusAmount'), width: '30%', classes: ''},
        {name: this.$t('bonusDescription'), width: '70%', classes: ''}
      ]
    },
    deductionColumns () {
      return [
        {name: this.$t('deductionAmount'), width: '30%', classes: ''},
        {name: this.$t('deductionDescription'), width: '70%', classes: ''}
      ]
    },
    computedSalary () {
      return Number(this.employee.salary_amount) + Number(this.bonusesSum) - Number(this.salaryDeductionsSum)
    },
    payslipsColumns () {
      return [
        { header: this.$t('date'), fieldName: 'date', show: true },
        { header: this.$t('basicSalary'), fieldName: 'amount', show: true }
      ]
    },
    payslipsData () {
      let formlatedPayslips = []

      window._.each(this.employee.user.payslips, payslip => {
        formlatedPayslips.push({
          id: payslip.id,
          amount: '£' + payslip.amount,
          date: window.moment(payslip.date).format('DD/MM/YYYY'),
          bonuses: payslip.bonus,
          salary_deductions: payslip.salary_deductions,
          totalSalaryAmount: '£' + (Number(payslip.amount) + this.listSumation(payslip.bonus) - this.listSumation(payslip.salary_deductions))
        })
      })

      return formlatedPayslips
    }
  },
  methods: {
    listSumation (list) {
      return window._.sumBy(list, listObject => {
        return Number(listObject.amount)
      })
    },
    showModal () {
      $('#employee-payslip').modal({
        centered: false
      }).modal('show')
    },
    hideModal () {
      this.wantToClear = true
      $('#employee-payslip').modal('hide')
      this.$nextTick(() => {
        this.wantToClear = false
      })
    },
    bonusesEventListenner (event) {
      this.bonusesSum = event.dataSumation
      this.bonuses = event.data
      this.bonusFormValid = event.isValid
    },
    deductionsEventListenner (event) {
      this.salaryDeductionsSum = event.dataSumation
      this.salaryDeductions = event.data
      this.deductionFormValid = event.isValid
    },
    savePayslip () {
      let payslipParams = {
        amount: this.employee.salary_amount,
        date: window.moment().toDate(),
        bonuses: this.bonuses,
        salary_deductions: this.salaryDeductions
      }
      this.$http.post(`employees/${this.employee.id}/add/payslip`, {
        payslip: payslipParams,
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(response => {
        this.employee.user.payslips.push(response.data)
        this.hideModal()
      })
    },
    discardChanges () {
      this.hideModal()
    },
    toggleThePopup (popupId) {
      $('#salary-' + popupId).popup('toggle')
    },
    amountRightToBeShown (amount) {
      return amount !== 0 && amount !== null
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/employees/employee_components/PayslipsPart.vue